import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { TrustpilotUspsBanner } from '@awaze/design-system.compositions.trustpilot-usps-banner'
import { useIntlContext } from '@awaze/mfe-common.contexts.intl'

import { OPTIMIZELY_FLAGS_ENUM } from 'src/constants/index'
import { useOptimizelyDecisionsContext } from 'src/context/optimizely-decisions-context'

import { TrustpilotConfiguration } from './trustpilotConfig'

interface SMFETrustpilotUspsBannerProps {
  brand: Brand
  locale: string
}

export const SMFETrustpilotUspsBanner = ({
  brand,
  locale,
}: SMFETrustpilotUspsBannerProps): JSX.Element | null => {
  const { formatMessage } = useIntlContext()
  const optiContext = useOptimizelyDecisionsContext()

  const showTrustpilotUSPBanner =
    optiContext?.getExperimentVariationKey(
      OPTIMIZELY_FLAGS_ENUM.GD_215_USP_BANNER,
    ) === 'variant_a'

  if (!showTrustpilotUSPBanner) {
    return null
  }

  const ukBrands = brand === 'cottages.com' || brand === 'hoseasons'

  return (
    <TrustpilotUspsBanner
      brand={brand}
      locale={locale}
      showTrustpilotWidget={true}
      trustPilotConfig={TrustpilotConfiguration}
      trustpilotTheme={brand === 'novasol' ? 'light' : 'dark'}
      useBrandColours={true}
      showUsps={true}
      usps={[
        formatMessage({
          id: ukBrands ? `trustpilot.usps.1.${brand}` : 'trustpilot.usps.1',
          defaultMessage: 'Book for 2026 - low first payment',
        }),
        formatMessage({
          id: ukBrands ? `trustpilot.usps.2.${brand}` : 'trustpilot.usps.2',
          defaultMessage: 'Book 2026 for 2025 prices',
        }),
        formatMessage({
          id: ukBrands ? `trustpilot.usps.3.${brand}` : 'trustpilot.usps.3',
          defaultMessage: 'Book direct for the best price',
        }),
      ]}
      overrideTrustpilotPadding={ukBrands}
    />
  )
}
